;(function () {
  'use strict'

  angular.module('contrast.profile').factory('ProfileService', ProfileService)

  function ProfileService(
    DEFAULT_DATETIME_FORMAT,
    DEFAULT_DATE_FORMAT,
    DEFAULT_TIME_FORMAT
  ) {
    'ngInject'

    var service = {
      buildProfile: buildProfile,
      setUser: setUser,
      getUser: getUser,
      getUid: getUid,
      getId: getId,
      getName: getName,
      getFirstName: getFirstName,
      getTimeFormat: getTimeFormat,
      getDateFormat: getDateFormat,
      getDateTimeFormat: getDateTimeFormat,
      getTimezone: getTimezone,
      getEmail: getEmail,
      getLanguage: getLanguage,
      setRASPEnabled: setRASPEnabled,
      isRASPEnabled: isRASPEnabled,
      setServerlessEnabled: setServerlessEnabled,
      isServerlessEnabled: isServerlessEnabled,
      getTsvType: getTsvType,
      setTsvType: setTsvType,
      getNewUserOnboardingPreference: getNewUserOnboardingPreference,
      setNewUserOnboardingPreference: setNewUserOnboardingPreference,
      getNewUserNotificationPreference: getNewUserNotificationPreference,
      setNewUserNotificationPreference: setNewUserNotificationPreference,
      isDiagnosticsCollectionEnabled: isDiagnosticsCollectionEnabled,
      setDiagnosticsCollectionEnabled: setDiagnosticsCollectionEnabled
    }

    return service

    function buildProfile(user) {
      var profile = {}
      profile.uid = user.user_uid
      if (user.group) {
        profile.group = user.group.name
      }
      profile.firstname = user.first_name
      profile.lastname = user.last_name
      profile.dateformat = user.preferences.date_format
      profile.timeformat = user.preferences.time_format
      profile.timezone = user.preferences.time_zone
      profile.language =
        user.preferences.language !== 'es' ? user.preferences.language : 'en'
      return profile
    }

    function setUser(user) {
      this.user = user
    }

    function getUser() {
      return this.user
    }

    function getUid() {
      return this.user ? this.user.user_uid : ''
    }

    function getId() {
      return this.user ? this.user.id : ''
    }

    function getName() {
      return this.user ? this.user.first_name + ' ' + this.user.last_name : ''
    }

    function getFirstName() {
      return this.user ? this.user.first_name : ''
    }

    function getTimeFormat() {
      return this.user ? this.user.preferences.time_format : DEFAULT_TIME_FORMAT
    }

    function getDateFormat() {
      return this.user ? this.user.preferences.date_format : DEFAULT_DATE_FORMAT
    }

    function getDateTimeFormat() {
      return this.user
        ? this.user.preferences.date_format +
            ' ' +
            this.user.preferences.time_format
        : DEFAULT_DATETIME_FORMAT
    }

    function getTimezone() {
      return this.user ? this.user.preferences.time_zone : 'EST'
    }

    function getEmail() {
      return this.user ? this.user.email : ''
    }

    function setRASPEnabled(access) {
      this.rasp_access = access.rasp_access
    }

    function isRASPEnabled() {
      return this.rasp_access
    }

    function setServerlessEnabled(access) {
      this.serverless_access = access.serverless_access
    }

    function isServerlessEnabled() {
      return this.serverless_access
    }

    function getTsvType() {
      return this.tsvType
    }

    function setTsvType(tsvType) {
      this.tsvType = tsvType
    }

    function getNewUserOnboardingPreference() {
      return this.newUserOnboardingPreference
    }

    function setNewUserOnboardingPreference(preference) {
      this.newUserOnboardingPreference = preference
    }

    function getNewUserNotificationPreference() {
      return this.newUserNotificationPreference
    }

    function getLanguage() {
      return this.user && this.user.preferences.language !== 'es'
        ? this.user.preferences.language
        : 'en'
    }

    function setNewUserNotificationPreference(preference) {
      this.newUserNotificationPreference = preference
    }

    function isDiagnosticsCollectionEnabled() {
      return this.diagnostics_enabled || false
    }

    function setDiagnosticsCollectionEnabled(enabled) {
      this.diagnostics_enabled = enabled
    }
  }
})()
